import React from "react";

const UserPaymentSuccess = () => {
  return (
    <div
      style={{
        minHeight: "320px",
        maxHeight: "500px",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(180deg, rgba(232,245,233,0.7) 0%, rgba(255,255,255,1) 100%)",
        padding: "20px",
        direction: "rtl",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "520px",
          maxHeight: "460px",
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
          padding: "28px 22px",
          textAlign: "center",
          border: "1px solid #e8f5e9",
        }}
      >
        <div style={{ fontSize: "50px", lineHeight: 1, marginBottom: "12px" }}>
          ✅
        </div>
        <h2 style={{ margin: "0 0 10px 0", color: "#1b5e20" }}>
          התשלום בוצע בהצלחה
        </h2>
        <p style={{ margin: 0, color: "#37474f", lineHeight: 1.7 }}>
          יש להמתין 2 דקות ולרענן את האתר.
          <br />
        </p>
        במידה ולא חל שינוי יש לפנות לתמיכה.
      </div>
    </div>
  );
};

export default UserPaymentSuccess;
